export default "__VITE_ASSET__CZyq034x__"